import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Élément #root introuvable');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * Service worker — enregistré APRÈS le rendu, et jamais en développement.
 *
 * En dev il masquerait les rechargements à chaud de Vite ; en production il ne
 * doit pas retarder le premier affichage. Un échec d'enregistrement est sans
 * conséquence : l'application fonctionne exactement pareil, elle n'est
 * simplement pas installable.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      console.warn('[pwa] service worker non enregistré :', err?.message ?? err);
    });
  });
}
